"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAdminApi = void 0;
var _react = require("react");
var _hooks = require("../../../hooks");
var _http = require("../../../utilities/http");
var _urls = require("../../../utilities/urls");
const useAdminApi = () => {
  const {
    isSessionDataReady,
    role
  } = (0, _hooks.useSessionData)();
  const getSchoolsAndSettlements = (0, _react.useCallback)(async () => {
    let schoolsAndSettlements = [];
    if (isSessionDataReady && role === 'admin') {
      await _http.http.get(`${_urls.ofakimApiUrl}/lmscp/getSchoolsAndSettlements`).then(response => {
        schoolsAndSettlements = response;
      }).catch(error => {
        schoolsAndSettlements = [];
      });
    }
    return schoolsAndSettlements;
  }, [isSessionDataReady, role]);
  return {
    getSchoolsAndSettlements
  };
};
exports.useAdminApi = useAdminApi;